import React, {useState, useEffect} from 'react';
import { Notification } from 'audamatic-ui';
import { useAuth } from '@utils/authentication/AuthProvider';
import Typeset from '@components/base_typeset/component';
import Text from '@components/ui_text/component';
import Space from '@components/ui_space/component';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const LogoutNotification = (props) => {
  const {wrappedInsideContainer = true, spacing = 0} = props;
  const auth = useAuth();
  const [showNotification, setShowNotification] = useState(false)
  const location = useLocation();

  useEffect(() => {
    const storedLoggedOut = sessionStorage.getItem('loggedout') === 'true';
    const storedPath = sessionStorage.getItem('logoutPath');

    // Check if the user is logged out and if the current path matches the path where the user logged out
    if (storedLoggedOut && !auth.user && storedPath === location.pathname) {
      setShowNotification(true);
    } else {
      setShowNotification(false);
      sessionStorage.removeItem('loggedout');
      sessionStorage.removeItem('logoutPath');
    }
  }, [auth, location]);

  return showNotification && (
    <div className={wrappedInsideContainer ? '' : 'container'}>
      <Notification closable={true}>
        <Typeset tag="div" tight bold><Text>account.logout.notification</Text></Typeset>
      </Notification>
      {spacing > 0 && <Space size={spacing} />}
    </div>
  );
}
LogoutNotification.propTypes = {
  wrappedInsideContainer: PropTypes.bool,
  spacing: PropTypes.number,
};

export default LogoutNotification;